module.exports = __webpack_public_path__ + "static/service02-7fde0d6c96f91debe11fbbe57d839427.jpg";